'use strict';

const SPORTS = require('../constants/sports');

const sportCategories = [
  {
    name: 'runningCategory',
    types: [
      SPORTS.RUNNING,
      SPORTS.TREADMILL,
      SPORTS.RUN_WHEELCHAIR,
    ],
  },
  {
    name: 'cyclingCategory',
    types: [
      SPORTS.CYCLING,
      SPORTS.INDOOR_CYCLING,
      SPORTS.HANDBIKE,
      SPORTS.ELECTRIC_BIKE,
      SPORTS.MOUNTAIN_BIKE,
    ],
  },
  {
    name: 'swimmingCategory',
    types: [
      SPORTS.SWIMMING,
    ],
  },
  {
    name: 'dailyCategory',
    types: [
      SPORTS.WALKING,
      SPORTS.WHEELCHAIR,
    ],
  },
  {
    name: 'fightCategory',
    types: [
      SPORTS.FENCING,
      SPORTS.BOXING,
      SPORTS.MARTIAL_ARTS,
    ],
  },
  {
    name: 'collectiveCategory',
    types: [
      SPORTS.BASKETBALL,
      SPORTS.HANDBALL,
      SPORTS.HOCKEY,
      SPORTS.RUGBY,
      SPORTS.SOCCER,
      SPORTS.VOLLEYBALL,
      SPORTS.AMERICAN_FOOTBALL,
      SPORTS.BASEBALL,
      SPORTS.WATER_POLO,
      SPORTS.PETANQUE,
      SPORTS.CRICKET,
      SPORTS.NETBALL,
    ],
  },
  {
    name: 'fitnessCategory',
    types: [
      SPORTS.ROWING,
      SPORTS.AQUAGYM,
      SPORTS.CROSSFIT,
      SPORTS.DANCE,
      SPORTS.WEIGHT_TRAINING,
      SPORTS.CARDIO_TRAINING,
      SPORTS.STREET_WORKOUT,
      SPORTS.ELLIPTICAL_TRAINER,
      SPORTS.INDOOR_ROWING,
    ],
  },
  {
    name: 'skatingCategory',
    types: [
      SPORTS.ICE_SKATING,
      SPORTS.SPEED_SKATING,
      SPORTS.ROLLER,
      SPORTS.SKIING,
      SPORTS.SNOWBOARD,
    ],
  },
  {
    name: 'outdoorCategory',
    types: [
      SPORTS.EXTREME_SPORTS,
      SPORTS.ARCHERY,
      SPORTS.GOLF,
      SPORTS.HORSE_RIDING,
      SPORTS.ROCK_CLIMB,
      SPORTS.ATHLETICS,
      SPORTS.ECO_ACTION,
    ],
  },
  {
    name: 'racketCategory',
    types: [
      SPORTS.BADMINTON,
      SPORTS.SQUASH,
      SPORTS.TABLE_TENNIS,
      SPORTS.TENNIS,
      SPORTS.PADEL,
    ],
  },
  {
    name: 'walkingCategory',
    types: [
      SPORTS.HIKING,
      SPORTS.WALK_WHEELCHAIR,
    ],
  },
  {
    name: 'waterCategory',
    types: [
      SPORTS.KAYAKING,
      SPORTS.SCUBA_DIVING,
      SPORTS.SAIL_AND_BOARD,
      SPORTS.KITESURF,
      SPORTS.SURF,
      SPORTS.WINDSURF,
    ],
  },
  {
    name: 'wellnessCategory',
    types: [
      SPORTS.MEDITATION,
      SPORTS.STRETCHING,
      SPORTS.YOGA,
      SPORTS.PILATE_GYM,
    ],
  },
  {
    name: 'othersCategory',
    types: [],
  },
];

module.exports = sportCategories;
